
export const getOrganizationPermissions = state => state.permissions.organization;
export const getSitePermissions = state => state.permissions.site;
export const getPreceptorPermissions = state => state.permissions.preceptor;
